import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import Modal from "react-bootstrap/es/Modal";
import axios from "axios";
import {BASE_URL, ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../configuration";
import {toast} from "react-toastify";
import {css} from "glamor";
import './AllCustomersRow.css';
import InitialQuotationState from "../../../Site/QuotationForm/InitialQuotationState";

class AllCustomersRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orderId: "",
            inquiryId: "",
            status: this.props.customerList.status,
            activateShow: false,
            deactivateShow: false,
            toAdminShow: false,
            billingAddress: {},
            address: null

        };
        this.truncate = this.truncate.bind(this);
        this.getInquiryId = this.getOrderId.bind(this);
        this.customerActivation = this.customerActivation.bind(this);
        this.deactivateHandleShow = this.deactivateHandleShow.bind(this);
        this.activateHandleShow = this.activateHandleShow.bind(this);
        this.deactivateHandleClose = this.deactivateHandleClose.bind(this);
        this.activateHandleClose = this.activateHandleClose.bind(this);
        this.toAdminModalShow = this.toAdminModalShow.bind(this);
        this.userIdPass = this.userIdPass.bind(this);
        this.impersonatePerson = this.impersonatePerson.bind(this);
    }


    userIdPass = (id) => {

        InitialQuotationState.selectedUserId = id;
    }
    customerActivation = (activation) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/users/activation/' + this.props.customerList.id + '/' + activation, axiosConfig)
            .then((res) => {
                if (res.data === "active") {
                    this.setState({
                        status: 'ACTIVE',
                        activateShow: false
                    }, () => this.props.getAllCustomers(0, ITEM_COUNT_PER_PAGE))
                } else {
                    this.setState({
                        status: res.data,
                        deactivateShow: false,
                    }, () => this.props.getAllCustomers(0, ITEM_COUNT_PER_PAGE))
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });

    };

    changeCustomerToAdmin = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        let userData = {
            name: this.props.customerList.name,
            japaneseFirstName: this.props.customerList.japaneseFirstName,
            japaneseLastName: this.props.customerList.japaneseLastName,
            lastName: this.props.customerList.lastName,
            firstName: this.props.customerList.firstName,
            email: this.props.customerList.email,
            userRole: "ADMIN",
            gender: this.props.customerList.gender,
            primaryAddress: this.props.customerList.primaryAddress,
            phone: this.props.customerList.phone,
            shippingAddressId: this.props.customerList.shippingAddressId,
            billingAddressId: this.props.customerList.billingAddressId,
            username: this.props.customerList.username
        };

        axios.put(RESOURCE_BASE_URL + 'api/users/' + this.props.customerList.id, userData, axiosConfig)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        toAdminShow: false
                    });

                    toast(<FormattedMessage id="app.admin-change-roles-success"
                            // defaultMessage="User role changed to Admin success."
                                            defaultMessage="ユーザー役割が管理者成功に変更されました。"
                                            description=""/>,
                        {
                            className: css({
                                background: "#ff9900 !important",
                                width: "auto",
                                padding: "25px",
                                color: "#000000 !important"
                            })
                        }, {autoClose: 2000});
                    this.props.getAllCustomers(0, 10);
                }
            })
            .catch((err) => {
                toast(<FormattedMessage id="app.admin-change-roles-fail"
                                        defaultMessage="エラーが発生しました。 役割を管理者に変更できませんでした。"
                    // defaultMessage="Error occurred. Could not changed te role to Admin !"
                                        description=""/>, {
                    className: css({
                        background: "#fa0000 !important",
                        width: "auto",
                        padding: "25px",
                        color: "#E5E5E5 !important",
                        fontWeight: "bold"
                    })
                }, {autoClose: 2000});
                console.log("ERROR: in change to Admin", err);
            });
    };

    deactivateHandleShow = () => {
        this.setState({
            deactivateShow: true,
            status: 'INACTIVE'
        })
    };
    activateHandleShow = () => {
        this.setState({
            activateShow: true,
            status: 'ACTIVE'

        })
    };

    deactivateHandleClose = () => {
        this.setState({
            deactivateShow: false,
        })
    };

    activateHandleClose = () => {
        this.setState({
            activateShow: false,
        })
    };

    toAdminModalShow = () => {
        this.setState({
            toAdminShow: true
        })
    };

    toAdminModalClose = () => {
        this.setState({
            toAdminShow: false
        })
    };

    getOrderId = () => {

        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.customerList.id + '/orders/last')
            .then((res) => {
                this.setState({
                    orderId: res.data.id,
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getInquiryId = () => {

        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.customerList.id + '/inquiries/last')
            .then((res) => {
                this.setState({
                    inquiryId: res.data.id,
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    impersonatePerson = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/user-new/impersonate/loginWithEmail/' + this.props.customerList.email, axiosConfig)
            .then((res) => {
                localStorage.setItem("oldTokenString", localStorage.getItem("tokenString"));
                localStorage.removeItem("tokenString");
                localStorage.setItem("newTokenString", res.data.payload.tokenString);
                localStorage.setItem("userRole", res.data.payload.userRole);
                window.location.href = BASE_URL + 'order/all';
            })
    };

    componentDidMount() {
        this.getOrderId();
        this.setState({
            address: this.props.customerList.address
        })
    }

    truncate(s) {
        if (s.length > 15) {
            return s.substring(0, 12) + "...";
        } else {
            return s;
        }

    };


    render() {
console.log("aaaa===>", this.props.customerList);
        return (
            <tr>
                <td className="customer-username-resp">{this.props.customerList.registeredDate}</td>
                <td className="customer-name-resp"> {this.props.customerList.japaneseLastName + " " +this.props.customerList.japaneseFirstName}</td>
                <td className="customer-email-resp">{this.props.customerList.email}</td>
                <td className="customer-actions-resp">
                    <Link to={"view/" + this.props.customerList.id} className="btn btn-xs btn-success">
                        <FormattedMessage id="app.all-customers-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>
                    &nbsp;
                    <Link to={"allOrders/" + this.props.customerList.id} className="btn btn-xs btn-primary">
                        <FormattedMessage id="app.all-customers-row.view-orders"
                                          defaultMessage="Orders"
                                          description=""/>
                    </Link>
                    &nbsp;

                    {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}

                    {/*<Link to={"inquiries/perUser/" + this.props.customerList.id} className="btn btn-xs btn-inquiry" >*/}
                    {/*<FormattedMessage id="app.all-customers-row.view-inquiries"*/}
                    {/*defaultMessage="Inquiry"*/}
                    {/*description=""/>*/}
                    {/*</Link>*/}


                    <Link to={"inquiries/perUser/" + this.props.customerList.id} className="btn btn-xs btn-inquiry"
                          onClick={() => this.userIdPass(this.props.customerList.id)}>
                        <FormattedMessage id="app.all-customers-row.view-inquiries"
                                          defaultMessage="Inquiry"
                                          description=""/>
                    </Link>


                    {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}


                    {/*<Link to={"inquiries/perUser/"+this.props.customerList.id} className="btn btn-xs btn-inquiry">*/}
                    {/*<FormattedMessage id="app.all-customers-row.view-inquiries"*/}
                    {/*defaultMessage="Inquiry"*/}
                    {/*description=""/>*/}
                    {/*</Link>*/}
                    {
                        this.props.customerList.status === "ACTIVE" ?
                            <button className="btn btn-xs btn-danger btn-activation"
                                    onClick={this.deactivateHandleShow}>
                                <FormattedMessage id="app.admin-all-row.deactivate"
                                                  defaultMessage="Deactivate"
                                                  description=""/>
                            </button>
                            :
                            <button className="btn btn-xs btn-success btn-activation"
                                    onClick={this.activateHandleShow}>
                                <FormattedMessage id="app.admin-all-row.activate"
                                                  defaultMessage="Activate"
                                                  description=""/>
                            </button>
                    }

                    {this.props.customerList.userRole === "USER" ?
                        <button className="btn btn-xs btn-primary btn-role-to-admin btn-role-to-admin2"
                                onClick={this.toAdminModalShow}>
                            <FormattedMessage id="app.admin-all-row.change-to-admin"
                                              defaultMessage="Set as Admin"
                                              description=""/>
                        </button> : ''
                    }

                    &nbsp;

                        <button className="btn btn-xs btn-primary" onClick={this.impersonatePerson}>
                            <FormattedMessage id="app.admin-all-row.impersonate"
                                              defaultMessage="Status"
                                              description=""/>
                        </button>


                    {/*deactivate customer -------------------*/}
                    <Modal dialogClassName="user-delete-modal" show={this.state.deactivateShow}
                           onHide={this.deactivateHandleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                {/*<FormattedMessage id="app.admin-all-row.deactivate-user"*/}
                                {/*defaultMessage="Deactivate User"*/}
                                {/*description=""/>*/}
                                アカウントの無効設定
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-12 data-label">

                                        {/*<FormattedMessage id="app.admin-all-row.deactivate-confirm"*/}
                                        {/*defaultMessage="Are you sure you want to deactivate the user ?"*/}
                                        {/*description=""/>*/}

                                        アカウントが無効に設定された場合、ログインできなくなります。
                                        <br/>
                                        <br/>
                                        <b><span className='font-color-red-allcustomer'>このアカウントを無効設定してもよろしいでしょうか。</span></b>
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.deactivateHandleClose}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                      defaultMessage="No"
                                                      description=""/>
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                        onClick={() => this.customerActivation(false)}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/*activate customer -----------------------*/}
                    <Modal dialogClassName="user-delete-modal" show={this.state.activateShow}
                           onHide={this.activateHandleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-all-row.activate-user"
                                                  defaultMessage="Activate User"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-8 data-label">

                                        <FormattedMessage id="app.admin-all-row.activate-confirm"
                                                          defaultMessage="Are you sure you want to activate the user ?"
                                                          description=""/>
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-primary col-md-2 pull-right" onClick={this.activateHandleClose}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                      defaultMessage="No"
                                                      description=""/>
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                        onClick={() => this.customerActivation(true)}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/*Change user to an Admin -------------------------------*/}

                    <Modal dialogClassName="to-admin-modal" show={this.state.toAdminShow} onHide={this.toAdminModalClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-all-row.change-to-admin"
                                                  defaultMessage="Set as Admin"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-12 data-label">

                                        <FormattedMessage id="app.admin-all-row.change-admin-confirm"
                                                          defaultMessage="Are you sure you want to change the user to an Admin?"
                                                          description=""/>
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-primary col-md-2 pull-right" onClick={this.toAdminModalClose}>
                                    <FormattedMessage id="app.admin-all-row.to-admin-no"
                                                      defaultMessage="No"
                                                      description=""/>
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                        onClick={this.changeCustomerToAdmin}>
                                    <FormattedMessage id="app.admin-all-row.to-admin-yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </td>
            </tr>
        )
    }
}

export default AllCustomersRow;



// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersRow/AllCustomersRow.js